import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Row, Section } from './model/custom.model';

export const CustomTemplateActions = createActionGroup({
  source: 'Custom Template',
  events: {
    'Load page': emptyProps(),
    'Load page success': emptyProps(),
    'Load page failed': props<{ error: string }>(),
    'Set Sections': props<{ sections: Section[] }>(),
    'Set Rows': props<{ rows: Row[] }>(),
  },
});
